import { Controller } from "stimulus"
import Sortable from 'sortablejs'

export default class extends Controller {
  static targets = ["available", "selected", "hiddenInputs", "availableSearch", "selectedSearch", "count"]

  connect() {
    this.fieldName = this.data.get("fieldName")
    this.initializeSortable()
    this.syncHiddenInputs()
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    this.element.addEventListener('keydown', this.boundHandleKeydown)
  }

  disconnect() {
    if (this.availableSortable) this.availableSortable.destroy()
    if (this.selectedSortable) this.selectedSortable.destroy()
    this.element.removeEventListener('keydown', this.boundHandleKeydown)
  }

  handleKeydown(event) {
    const item = event.target.closest('[data-community-id]')
    if (!item) return

    switch(event.key) {
      case 'ArrowRight':
      case 'Enter':
        if (this.availableTarget.contains(item)) {
          event.preventDefault()
          this.selectedTarget.appendChild(item)
          this.transformItemForSide(item, 'selected')
          this.syncHiddenInputs()
          item.focus()
        }
        break
      case 'ArrowLeft':
      case 'Backspace':
        if (this.selectedTarget.contains(item)) {
          event.preventDefault()
          this.availableTarget.appendChild(item)
          this.transformItemForSide(item, 'available')
          this.syncHiddenInputs()
          item.focus()
        }
        break
      case 'ArrowUp':
        event.preventDefault()
        this.focusSibling(item, -1)
        break
      case 'ArrowDown':
        event.preventDefault()
        this.focusSibling(item, 1)
        break
    }
  }

  focusSibling(item, direction) {
    const items = Array.from(item.parentElement.querySelectorAll('[data-community-id]:not([style*="display: none"])'))
    const currentIndex = items.indexOf(item)
    const nextIndex = currentIndex + direction
    if (nextIndex >= 0 && nextIndex < items.length) {
      items[nextIndex].focus()
    }
  }

  initializeSortable() {
    const baseOptions = {
      group: 'communities',
      animation: 150,
      ghostClass: 'dual-list__item--ghost',
      onEnd: () => this.syncHiddenInputs()
    }

    this.availableSortable = Sortable.create(this.availableTarget, {
      ...baseOptions,
      onAdd: (evt) => {
        this.transformItemForSide(evt.item, 'available')
      }
    })

    this.selectedSortable = Sortable.create(this.selectedTarget, {
      ...baseOptions,
      onAdd: (evt) => {
        this.transformItemForSide(evt.item, 'selected')
      }
    })
  }

  syncHiddenInputs() {
    this.hiddenInputsTarget.innerHTML = ''

    const selectedItems = this.selectedTarget.querySelectorAll('[data-community-id]')
    selectedItems.forEach(item => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = this.fieldName
      input.value = item.dataset.communityId
      this.hiddenInputsTarget.appendChild(input)
    })

    this.updateCount(selectedItems.length)
  }

  updateCount(count) {
    if (this.hasCountTarget) {
      this.countTarget.textContent = count
    }
  }

  moveToSelected(event) {
    const item = event.currentTarget.closest('[data-community-id]')
    this.selectedTarget.appendChild(item)
    this.transformItemForSide(item, 'selected')
    this.syncHiddenInputs()
  }

  moveToAvailable(event) {
    const item = event.currentTarget.closest('[data-community-id]')
    this.availableTarget.appendChild(item)
    this.transformItemForSide(item, 'available')
    this.syncHiddenInputs()
  }

  moveAllToSelected() {
    this.availableTarget.querySelectorAll('[data-community-id]').forEach(item => {
      this.selectedTarget.appendChild(item)
      this.transformItemForSide(item, 'selected')
    })
    this.syncHiddenInputs()
  }

  moveAllToAvailable() {
    this.selectedTarget.querySelectorAll('[data-community-id]').forEach(item => {
      this.availableTarget.appendChild(item)
      this.transformItemForSide(item, 'available')
    })
    this.syncHiddenInputs()
  }

  filterAvailable(event) {
    this.filterList(this.availableTarget, event.target.value)
  }

  filterSelected(event) {
    this.filterList(this.selectedTarget, event.target.value)
  }

  filterList(list, query) {
    const normalizedQuery = query.toLowerCase().trim()
    list.querySelectorAll('[data-community-id]').forEach(item => {
      const name = item.dataset.communityName.toLowerCase()
      item.style.display = name.includes(normalizedQuery) ? '' : 'none'
    })
  }

  transformItemForSide(item, side) {
    const button = item.querySelector('button')
    const nameSpan = item.querySelector('.dual-list__item-name')
    if (!button || !nameSpan) return

    const icon = button.querySelector('i')
    if (!icon) return

    if (side === 'available') {
      // Available side: name first, then button with primary styling and right chevron
      button.classList.remove('btn-outline-danger')
      button.classList.add('btn-outline-primary')
      button.dataset.action = 'click->dual-list#moveToSelected'
      icon.classList.remove('fa-chevron-left')
      icon.classList.add('fa-chevron-right')
      // Reorder: name span first, button second
      item.insertBefore(nameSpan, button)
    } else {
      // Selected side: button first with danger styling and left chevron, then name
      button.classList.remove('btn-outline-primary')
      button.classList.add('btn-outline-danger')
      button.dataset.action = 'click->dual-list#moveToAvailable'
      icon.classList.remove('fa-chevron-right')
      icon.classList.add('fa-chevron-left')
      // Reorder: button first, name span second
      item.insertBefore(button, nameSpan)
    }
  }
}
